import BatabotActionTypes from "./batabot.types";

const INITIAL_STATE = {
  access: null,
};

const batabotReducer = (state = INITIAL_STATE, action) => {
  console.log("PL BB", action);
  switch (action.type) {
    case BatabotActionTypes.GET_ACCESS:
      return { ...state, access: action.payload };
    default:
      return state;
  }
};

export default batabotReducer;
